import useAppStore from "@/context/store";
import { isGdMerged } from "../gaoding";

/**是否是素材会员 */
export function useIsMaterialVip() {
  const { user, vips } = useAppStore((s) => ({ user: s.user, vips: s.vips }));

  if (!user) return false;

  return isGdMerged(user) ? vips.length > 0 : user?.extra?.material_vip > 0;
}
